import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import StateMachine from "slotworks/state-machine/state-machine";
import { AbstractControl } from "../control";

export default class SkipAreaControl extends AbstractControl {

    private skipArea: PIXI.Sprite;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.skipArea = layer.getSprite(assetName);
        if (this.skipArea) {
            this.skipArea.interactive = true;
            this.skipArea.addListener(ButtonEvent.CLICK.getPIXIEventString() as any, () => this.onButtonPressed());
        }
    }

    public destroy() {
        if (this.skipArea) {
            this.skipArea.removeAllListeners();
            this.skipArea = null;
        }

        super.destroy();
    }

    public setEnabled(enabled: boolean): void {
        this.skipArea.interactive = enabled;

        super.setEnabled(enabled);
    }

    protected onButtonPressed() {
        StateMachine.skip();
    }
}
